import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import IMG_HUNT_GROUPS_MULTIPLE from 'images/wallboard/hunt_groups_multiple.png';
import IMG_TEAM_CUSTOM from 'images/wallboard/team_custom.png';

interface Props {
    boardType: 'hunt_groups_multiple' | 'team_custom';
}

const DashboardTemplateItem = ({ boardType }: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex flex-col items-center justify-center gap-3">
            <img
                className="h-[90px] w-[160px]"
                src={
                    boardType === 'hunt_groups_multiple'
                        ? IMG_HUNT_GROUPS_MULTIPLE
                        : IMG_TEAM_CUSTOM
                }
                alt={i18next.t(`wallboard.description.${boardType}`)}
            />
            <p className="text-center">
                <span className="flex h-6 items-center justify-center text-sm">
                    {i18next.t(`wallboard.title.${boardType}`)}
                </span>
                <span className={'text-xs'}>
                    {i18next.t(`wallboard.description.${boardType}`)}
                </span>
            </p>
        </div>
    );
};

export default React.memo(DashboardTemplateItem);
